function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HelpCenterService from './js/help_center_service';
import tasks from '@/js/tasks';
import { VueEditor } from "vue2-editor";
import config from '@/configs';
import { firebaseConfig, GA_EVENTS } from '@/js/constants';
import { mapState } from 'vuex';
export default _defineProperty({
  components: {
    VueEditor: VueEditor
  },
  props: {
    isModal: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      content: "",
      preguntas: [],
      editorOptions: {
        modules: {
          toolbar: false
        }
      },
      tab: 0,
      model: [],
      modules: ['data_platform', 'audience', 'attributes', 'customer_insights', 'analytic_services'],
      carouselReady: false
    };
  },
  created: function created() {
    this.getPreguntas();
    console.log(this.$i18n.locale);
    this.sendtoGA(this.tab);
  },
  computed: {},
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    sendtoGA: function sendtoGA(index_tab) {
      console.log("ga", index_tab);
      var module_ = 0;
      switch (index_tab) {
        case 0:
          module_ = "data_platform";
          break;
        case 1:
          module_ = "digital_audiences";
          break;
        case 2:
          module_ = "attributes_marketplace";
          break;
        case 3:
          module_ = "customer_insights";
          break;
        case 4:
          module_ = "analytic_services";
          break;
      }
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: GA_EVENTS.HELP_CENTER_VIEW,
          type: 'read_and_learn',
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          'module': module_
        });
      }
    },
    getBack: function getBack() {
      this.$router.push({
        name: "help_main"
      });
    },
    getPreguntas: function getPreguntas() {
      var _this = this;
      HelpCenterService.getQuestions().then(function (response) {
        console.log(response);
        if (response.success === true) _this.modules.forEach(function (_module) {
          response.data.forEach(function (object) {
            if (object.module == _module) _this.preguntas.push(object);
          });
        });
        //this.preguntas=response.data
        console.log("preguntas:", _this.preguntas);
      }, function (err) {
        tasks.toast.error('Error');
        //this.$toast.warning("Error")
      });
    }
  }
}, "computed", _objectSpread({
  breadcrumbs: function breadcrumbs() {
    return [{
      text: this.traductor('help_center.help_center'),
      disabled: false,
      href: '/#/help_center/MainPage'
    }, {
      text: "Lee y Aprende",
      disabled: true
    }];
  }
}, mapState('data-platform', ['companyCode', 'companyName'])));